interface CabinCacheData {
  pageData: any;
  tripsInfo: TripsInfo;
}

type DataFetchFunction = (tripsInfo: TripsInfo) => Promise<any>;

export default class CabinDataManager {
  private cabinCache: { [key: string]: CabinCacheData } = {};
  private readonly storeName: string;
  private fetchDataFn: DataFetchFunction;

  constructor(className: string, fetchDataFn: DataFetchFunction) {
    this.storeName = className;
    this.fetchDataFn = fetchDataFn;
  }

  private getCacheKeyFromTripsInfo(tripsInfo: TripsInfo): string {
    const key = tripsInfo.isRoundTrip
      ? `${tripsInfo.departCabinClass}-${tripsInfo.returnCabinClass}`
      : tripsInfo.departCabinClass;

    return key;
  }

  async getCabinData(tripsInfo: TripsInfo): Promise<CabinCacheData> {
    const cacheKey = this.getCacheKeyFromTripsInfo(tripsInfo);

    // Return cached data if exists
    if (this.cabinCache[cacheKey]) {
      return this.cabinCache[cacheKey];
    }

    // Fetch new data using the provided fetch function
    const newPageData = await this.fetchDataFn(tripsInfo);

    // Cache the result
    const newCacheData = {
      pageData: newPageData,
      tripsInfo: tripsInfo,
    };
    this.cabinCache[cacheKey] = newCacheData;

    return newCacheData;
  }

  clearCache() {
    this.cabinCache = {};
  }
}
